import "./tile.css"

import { memo } from "react"

import { Direction } from "@/generated/TradingGateway"
import { CurrencyPair } from "@/services/currencyPairs"
import { isMobileDevice } from "@/utils"
import { useIsDesktop } from "@/utils/useIsDesktop"

import { ExecutionResponse } from "./ExecutionResponse"
import { HistoricalGraph } from "./HistoricalGraph"
import { PriceButton } from "./PriceButton"
import { PriceMovement } from "./PriceMovement"
import { useIsSymbolDataStale } from "./tile.state"
import { TileContext, useTileContext } from "./TileContext"
import { TileFooter } from "./TileFooter"
import { TileHeader } from "./TileHeader"
import { TileRfqButton } from "./TileRfqButton"

const TileInner = () => {
  useIsSymbolDataStale()

  const { supportsTearOut, showingChart } = useTileContext()

  return (
    <div
      // relative for execution response
      className={`relative ${supportsTearOut ? "tile" : ""} flex hover:text-brand-primary`}
    >
      <div
        className={`flex min-h-[152px] w-full flex-1 flex-col bg-primary shadow-[0_2px_20px] shadow-(color:--bg-secondary)`}
      >
        <TileHeader />
        <div
          // relative for rfq button
          className={`relative flex flex-1 py-xs ${showingChart ? "min-h-[136px] flex-row items-center" : "min-h-0 flex-col"}`}
        >
          {showingChart ? <HistoricalGraph /> : null}
          <div
            className={`grid h-full flex-1 ${showingChart ? "price_showing-chart" : "price_hiding-chart"}`}
          >
            <PriceButton direction={Direction.Sell} />
            <PriceMovement />
            <PriceButton direction={Direction.Buy} />
            <TileRfqButton />
          </div>
        </div>
        <TileFooter />
      </div>
      <ExecutionResponse />
    </div>
  )
}

export const Tile = memo(function Tile({
  currencyPair,
  showingChart,
  isTornOut = false,
  supportsTearOut = true,
}: {
  currencyPair: CurrencyPair
  showingChart: boolean
  isTornOut?: boolean
  supportsTearOut?: boolean
}) {
  // A torn-out tile window is narrower than the desktop breakpoint, but must
  // keep its pop-in icon
  const showTearOut = useIsDesktop() || isTornOut

  return (
    <TileContext.Provider
      value={{
        currencyPair,
        isTornOut,
        supportsTearOut: supportsTearOut && !isMobileDevice && showTearOut,
        showingChart: showingChart,
      }}
    >
      <TileInner />
    </TileContext.Provider>
  )
})
